module.exports = __webpack_public_path__ + "img/yamaguchi_brl.e5eb992b.jpg";